import { NEUTRAL_800, NEUTRAL_400 } from 'visitor-ui-component-library/constants/WidgetColors';
import styled from 'styled-components';
import KnowledgeBaseIcon from './icons/KnowledgeBaseIcon';
import FormattedMessage from 'I18n/components/FormattedMessage';
import ExternalLinkIcon from './icons/ExternalLinkIcon';
import { useCallback } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SourceListWrapper = styled.div.withConfig({
  displayName: "SourceList__SourceListWrapper"
})(["width:100%;"]);
const SourceListHeader = styled.div.withConfig({
  displayName: "SourceList__SourceListHeader"
})(["font-size:12px;line-height:24px;font-weight:500;color:", ";"], NEUTRAL_800);
const SourceOl = styled.ol.withConfig({
  displayName: "SourceList__SourceOl"
})(["border-left:2px solid ", ";margin:6px 0px;display:flex;flex-direction:column;gap:8px;counter-reset:source-counter;padding-left:8px;list-style:none;"], NEUTRAL_400);
const SourceLi = styled.li.withConfig({
  displayName: "SourceList__SourceLi"
})(["display:flex;align-items:center;border-radius:4px;overflow:hidden;"]);
const SourceLink = styled.a.withConfig({
  displayName: "SourceList__SourceLink"
})(["flex:1;display:flex;align-items:center;gap:6px;overflow:hidden;font-size:12px;line-height:14px;font-weight:500;color:", ";text-decoration:none;"], ({
  theme
}) => theme.colors.primary);
const SourceLinkLabel = styled.span.withConfig({
  displayName: "SourceList__SourceLinkLabel"
})(["flex:1;overflow:hidden;white-space:nowrap;text-overflow:ellipsis;"]);
const SourceLinkIcon = styled.span.withConfig({
  displayName: "SourceList__SourceLinkIcon"
})(["flex:0 0 auto;display:flex;align-items:center;"]);
export default function SourceList({
  browserWindowHeight,
  navigateToKnowledgeBaseArticle = () => {},
  sources,
  trackInteraction = () => {}
}) {
  const onCitationClick = useCallback(src => e => {
    if (src.hubSpotContentType === 'KB_ARTICLE') {
      e.preventDefault();
      navigateToKnowledgeBaseArticle({
        deepLink: src.deepLink,
        hubSpotContentId: src.hubSpotContentId,
        hubSpotContentTextFragment: src.hubSpotContentTextFragment
      }, browserWindowHeight);
    }
    trackInteraction('Widget Interaction', {
      action: 'clicked citation'
    });
  }, [browserWindowHeight, navigateToKnowledgeBaseArticle, trackInteraction]);
  return /*#__PURE__*/_jsxs(SourceListWrapper, {
    children: [/*#__PURE__*/_jsx(SourceListHeader, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "conversations-visitor-message-history.sources"
      })
    }), /*#__PURE__*/_jsx(SourceOl, {
      children: sources.map((source, index) => /*#__PURE__*/_jsx(SourceLi, {
        children: /*#__PURE__*/_jsxs(SourceLink, {
          onClick: onCitationClick(source),
          target: "_blank",
          href: source.deepLink || source.url,
          children: [/*#__PURE__*/_jsxs(SourceLinkLabel, {
            children: [index + 1, "\xA0\xA0", source.title || source.url]
          }), /*#__PURE__*/_jsx(SourceLinkIcon, {
            children: source.hubSpotContentType === 'KB_ARTICLE' ? /*#__PURE__*/_jsx(KnowledgeBaseIcon, {}) : /*#__PURE__*/_jsx(ExternalLinkIcon, {})
          })]
        })
      }, source.citationId))
    })]
  });
}
SourceList.displayName = 'SourceList';